module.exports = "/assets/b4ab18f188e7539480dc6765e506e1e9.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/3O.png
// module id = 2146
// module chunks = 0